import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

// The journey (with its route, execution state and what the caller may do) and
// its city visits. They load independently: the visits need the city-visits
// permission, so a role without it still sees the journey, just without the
// per-city visit details.
export default function useTspJourneyDetailData(journeyId) {
  const journey = useTspApiResource(() => TspApiService.getJourney(journeyId), [journeyId]);
  const visits = useTspApiResource(() => TspApiService.listCityVisits({ journey_id: journeyId, limit: 100 }), [journeyId]);

  const reload = () => {
    journey.reload();
    visits.reload();
  };

  return { journey, visits, reload };
}
